import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    offset: -250,
})

export const panelTabsMixin = {
	props: {
		tab: {
			type: Object
		}
	},
}